<template>
  <div>
    <div class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center profile-header"
        style="min-height: 200px;">
      <b-container fluid>
        <span class="mask bg-gradient-success opacity-8"></span>
      </b-container>
    </div>
    <b-container v-if="isLoading" fluid class="mt--7">
      <card><p>Loading...</p></card>
    </b-container>
    <b-container v-else fluid class="mt--7">
      <card>
        <b-row>
          <b-col>
            <p v-if="isLoading">Loading...</p>
            <edit-domain-form v-else :domain="domain" :tagList="tagList" ref="edit-domain-form" ></edit-domain-form>
            <!-- <edit-domain-form v-else v-model:domain = "domain" ></edit-domain-form> -->
          </b-col>
        </b-row>
      </card>
      <card>
        <b-row class="domain-jobs">
          <h2>Jobs</h2>
          <div></div>
          <base-button 
            icon 
            type="info"
            :disabled="domain.id===null" 
            @click="addJob()"
            v-b-tooltip.hover :title="domain.id===null ? 'Create domain first to add new job' : 'Create job'">
              <span class="btn-inner--icon">
                <i class="ni ni-fat-add"/>
              </span>      
          </base-button>
                  <!-- Tooltip güzel çalışmıyo, disabled iken sorun yok : https://bootstrap-vue.org/docs/components/tooltip -->
        </b-row>
      </card>
      <card v-if="domain.jobs.length===0">
        <h5>No jobs</h5>
      </card>
      <job v-for="(job,index) in domain.jobs" v-bind:key="index" :jobData="job" @tag-list="testFunction"/> 
    </b-container>
    
  </div>
</template>
<script>
import EditDomainForm from './components/EditDomainForm.vue';
import Repository from '@/repositories/RepositoryFactory'
import Job from './components/Job.vue'

const DomainRepository=Repository.get('domain');

export default {
  props:{
    id:String
  },
  emits: ['update:tag-list'],
  components: {
    EditDomainForm,
    Job
  },
  data(){
    return {
      isLoading:true,
      domain:null,
      tagList:null
    }
  },
  created() {
    if(this.id==="new") {
      this.domain={
        id:null,
        name:'',
        domain_address:'',
        default_headers:null,
        default_body:null,
        default_method:0,
        is_active:true,
        jobs:[],
      }
      
      this.isLoading=false;

      return;
    }
    
    DomainRepository.get(this.id).then((response) => {
      this.domain=response.data[0];
      this.domain.tagList=this.tagList;
      if(this.domain.jobs.length===0)
        this.addJob();
      this.isLoading=false;
    })

  },
  methods: {
    testFunction(taglist){
      this.$refs['edit-domain-form'].updateTagList(taglist);
  
    },
    addJob(){
      var job={
        id:null,
        domain:{
          id:this.domain.id,
          name:this.domain.name,
          domain_address:this.domain_address,
          default_headers:this.default_headers,
          default_body:this.default_body,
          default_method:this.default_method,
        },
        name:(this.domain.name.toLowerCase()+'_job').replaceAll(' ','_'),
        operations:[]
      }
      this.domain.jobs.push(job);
      this.$forceUpdate();
    },
    removeJob(id){
      for(var i in this.domain.jobs){
        if(this.domain.jobs[i].id===id){
          this.domain.jobs.splice(i,1);
          this.$forceUpdate();
          return
        }
      }
    }
  }
};
</script>

<style>
.domain-jobs{
  display:flex;
  flex-direction: row;
  justify-content: space-around;
  column-gap:31%;
}
</style>
